import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Carousel, CarouselVariant, GiftCardMainSlide, Text, TextSize, } from '@as/cotopaxi';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { getImageFromCdn } from '../../util/ImageUtil';
export const GiftVoucherMainSlider = ({ activeSlideIndex, brand, images, onActiveSlideIndexChange, hideImageOverlay, imageCdnPrefix, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.general);
    const [swiper, setSwiper] = useState(null);
    const onGallerySlideChange = function () {
        onActiveSlideIndexChange(this.activeIndex);
    };
    const renderSlide = useCallback((image, index) => {
        const imagePath = getImageFromCdn(image, imageCdnPrefix, '1024');
        return (_jsx("div", { children: _jsx(GiftCardMainSlide, { imagePath: imagePath }) }, `gift_voucher_main_${index}`));
    }, [images]);
    const giftVoucherSlideOverlay = !hideImageOverlay ? (_jsxs(Box, { mobile: { spacing: { marginTop: 2, marginLeft: 2 } }, desktop: { spacing: { marginTop: 3, marginLeft: 3 } }, children: [_jsx(Text, { size: TextSize.XLARGE, children: brand }), _jsx(Text, { size: TextSize.XLARGE, children: t('voucher.cadeaucheque') })] })) : (_jsx(_Fragment, {}));
    const giftVoucherSlideConfig = {
        variant: CarouselVariant.GIFT_CARD_MAIN,
        showPagination: false,
        configurationOverrides: {
            getSwiper: setSwiper,
            watchOverflow: true,
            centeredSlides: true,
            effect: 'fade',
            on: {
                slideChange: onGallerySlideChange,
            },
        },
        overlay: giftVoucherSlideOverlay,
    };
    useEffect(() => {
        if (swiper !== null) {
            swiper.slideTo(activeSlideIndex);
        }
    }, [activeSlideIndex]);
    return (_jsx(Carousel, Object.assign({}, giftVoucherSlideConfig, { dataQA: "gift_voucher_main_slider", children: images.map(renderSlide) })));
};
